// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { customerPartNumberItemStyles } from "@steiner/App/Components/CustomerPartNumbers/CustomerPartNumberItem";
import Edit from "@steiner/XDL/Icons/Edit";
import Plus from "@steiner/XDL/Icons/Plus";
import Trash from "@steiner/XDL/Icons/Trash";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { ellipsis, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

customerPartNumberItemStyles.productDescriptionCell = {
    mergeCss: true,
    css: css`
        width: 882px;
        word-wrap: break-word;
        white-space: normal;
        vertical-align: baseline;
        ${xScreen("gte", "xl")} {
            width: 1037px;
        }
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

customerPartNumberItemStyles.partNumberCell = {
    mergeCss: true,
    css: css`
        min-width: 212px;
        vertical-align: baseline;
        ${xScreen("gte", "xl")} {
            min-width: 200px;
            white-space: normal;
        }
        ${xScreen("lte", "md")} {
            height: 34px;
        }
    `,
};

customerPartNumberItemStyles.editCell = {
    mergeCss: true,
    css: css`
        min-width: 120px;
        vertical-align: baseline;
        ${xScreen("gte", "xl")} {
            min-width: 141px;
        }
        ${xScreen("lte", "md")} {
            height: 34px;
        }
    `,
};

customerPartNumberItemStyles.deleteCell = {
    mergeCss: true,
    css: css`
        vertical-align: baseline;
        /* to override datatable style */
        &&& > ${StyledButton} {
            ${TypographyStyle} {
                font-size: 12px;
                line-height: 15px;
            }
        }
        width: 120px;
        ${xScreen("gte", "xl")} {
            width: 141px;
        }
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

customerPartNumberItemStyles.addToListCell = {
    mergeCss: true,
    css: css`
        /* to override datatable style */
        & > ${StyledButton} {
            ${TypographyStyle} {
                font-size: 12px;
                line-height: 15px;
            }
        }
    `,
};

customerPartNumberItemStyles.productDescriptionLink = {
    typographyProps: {
        size: 14,
        lineHeight: "22px",
        css: css`
            ${xScreen("gt", "lg")} {
                ${ellipsis(1)}
            }
        `,
    },
};

customerPartNumberItemStyles.productDescriptionText = {
    size: 14,
    lineHeight: "22px",
    css: css`
        ${ellipsis(1)}
    `,
};

customerPartNumberItemStyles.editLink = {
    icon: {
        iconProps: {
            src: Edit,
            size: 13,
            css: css`
                opacity: 0.66;
                margin-right: 6px;
            `,
        },
    },
    typographyProps: {
        size: 12,
        lineHeight: "15px",
    },
};

customerPartNumberItemStyles.updatePartNumberButton = {
    variant: "secondary",
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
    },
};

customerPartNumberItemStyles.deleteLink = {
    icon: {
        iconProps: {
            src: Trash,
            size: 15,
            css: css`
                opacity: 0.66;
                margin-right: 6px;
            `,
        },
    },
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
    },
};

customerPartNumberItemStyles.productAddToListLinkStyles = {
    link: {
        icon: {
            iconProps: {
                src: Plus,
                size: 13,
                css: css`
                    opacity: 0.66;
                    margin-right: 6px;
                `,
            },
        },
        typographyProps: {
            size: fontConfig.fontSize.xSmall,
            lineHeight: fontConfig.lineHeight.xSmall,
        },
    },
};

customerPartNumberItemStyles.addToCartCell = {
    css: css`
        ${xScreen("lte", "md")} {
            & > ${TypographyStyle} {
                display: flex;
                align-items: center;
            }
        }
    `,
};

customerPartNumberItemStyles.actionsContainer = {
    css: css`
        display: flex;
        gap: 12px 20px;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
        }
    `,
};

customerPartNumberItemStyles.modalGridContainer = {
    gap: 16,
};

customerPartNumberItemStyles.modalGridItem = {
    width: 12,
};

customerPartNumberItemStyles.modalProductDescriptionLinkStyle = {
    css: css`
        display: inline;
    `,
};

customerPartNumberItemStyles.modalErpNumberLinkStyle = {
    css: css`
        display: inline;
    `,
};

customerPartNumberItemStyles.modalCancelButton = {
    width: 6,
};

customerPartNumberItemStyles.modalConfirmButton = {
    width: 6,
    css: css`
        justify-content: end;
    `,
};


customerPartNumberItemStyles.productDescriptionWrapper = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 4px;
    `,
};